<div class="cont">
    <app-feature-flags></app-feature-flags>
</div>
